import styles from '@/styles/chat.module.scss';

/**
 * OptionButton — кнопка варианта ответа.
 * variant: 'default' | 'primary' | 'accent'
 */
export default function OptionButton({ children, onClick, variant = 'default', className = '', icon, disabled = false }) {
  const cls = [
    styles.optBtn,
    icon ? styles.withIcon : '',
    variant === 'primary' ? styles.primary : '',
    variant === 'accent'  ? styles.accent  : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button className={cls} onClick={onClick} type="button" disabled={disabled}>
      {icon && <span className={styles.optIcon}>{icon}</span>}
      {children}
    </button>
  );
}
